import React from "react";
import GlobalDialog from "../mui/Dialogue/GlobalDialog";
import {
    AddButton,
    CancelButton,
    EditButton,
    SaveButton,
} from "../mui/Buttons/Buttons";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import { useFormik, Form, FormikProvider } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
    editCategories,
    getProjectCategories,
    getProjectsPreData,
} from "../../redux/features/mastersSlice";
import { useSnackbar } from "notistack";

export const EditprojectCategory = ({ params }) => {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);
    const data = useSelector((state) => state.masters);
    const [value, setValue] = React.useState({
        id: params?.projectId || "",
        name: params?.projectName || "",
    });

    const Schema = Yup.object().shape({
        categoryDescription: Yup.string().required(
            "categoryDescription is required"
        ),
        categoryName: Yup.string().required("categoryName is required"),
        projectId: Yup.string().required("projectId is required"),
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            categoryId: params.categoryId,
            projectId: params.projectId || "",
            categoryName: params.categoryName || "",
            categoryDescription: params.categoryDescription || "",
        },
        validationSchema: Schema,
        onSubmit: (values, { resetForm }) => {
            console.log(values);
            dispatch(editCategories(values)).then((res) => {
                if (res.payload.status === "failed") {
                    enqueueSnackbar(res.payload.message, { variant: "error" });
                } else if (res.payload.status === "success") {
                    setOpen(false);
                    resetForm();
                    dispatch(getProjectCategories());
                    enqueueSnackbar(res.payload.message, {
                        variant: "success",
                    });
                }
            });
        },
    });
    return (
        <div>
            <GlobalDialog
                title="Add Project Category"
                open={open}
                setOpen={setOpen}
                fullWidth
                maxWidth={"sm"}
                popupButton={
                    <Box padding={1}>
                        <EditButton
                            size="small"
                            action={() => {
                                dispatch(getProjectsPreData());
                                setOpen(true);
                            }}
                        >
                            Edit
                        </EditButton>
                    </Box>
                }
                content={
                    <>
                        <FormikProvider value={formik}>
                            <Form onSubmit={formik.handleSubmit}>
                                <Box>
                                    <Stack direction={"column"} spacing={2}>
                                        <Autocomplete
                                            disablePortal
                                            name="projectId"
                                            value={value}
                                            id="combo-box-demo"
                                            options={data.projectsPreData}
                                            isOptionEqualToValue={(
                                                option,
                                                value
                                            ) =>
                                                option.id ||
                                                "" === value.id ||
                                                ""
                                            }
                                            getOptionLabel={(option) =>
                                                option.name || ""
                                            }
                                            onChange={(e, option, newValue) => {
                                                setValue({
                                                    id: option.id || "",
                                                    name: option.name || "",
                                                });
                                                formik.setFieldValue(
                                                    "projectId",
                                                    option.id
                                                );
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    disabled
                                                    fullWidth
                                                    {...params}
                                                    label="Project"
                                                    error={
                                                        formik.touched
                                                            .projectId &&
                                                        Boolean(
                                                            formik.errors
                                                                .projectId
                                                        )
                                                    }
                                                    helperText={
                                                        formik.errors.projectId
                                                    }
                                                />
                                            )}
                                        />
                                        <TextField
                                            label="Category Name"
                                            fullWidth
                                            name="categoryName"
                                            value={formik.values.categoryName}
                                            onChange={formik.handleChange}
                                            error={
                                                formik.touched.categoryName &&
                                                Boolean(
                                                    formik.errors.categoryName
                                                )
                                            }
                                            helperText={
                                                formik.errors.categoryName
                                            }
                                        />

                                        <TextField
                                            label="Category Description"
                                            fullWidth
                                            name="categoryDescription"
                                            value={
                                                formik.values
                                                    .categoryDescription
                                            }
                                            multiline
                                            rows={3}
                                            onChange={formik.handleChange}
                                            error={
                                                formik.touched
                                                    .categoryDescription &&
                                                Boolean(
                                                    formik.errors
                                                        .categoryDescription
                                                )
                                            }
                                            helperText={
                                                formik.errors
                                                    .categoryDescription
                                            }
                                        />
                                    </Stack>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            marginTop: 2,
                                        }}
                                    >
                                        <Stack spacing={2} direction={"row"}>
                                            <CancelButton
                                                action={() => setOpen(false)}
                                            >
                                                Cancel
                                            </CancelButton>
                                            <SaveButton type="submit">
                                                {data.loading
                                                    ? "Saving..."
                                                    : "Save"}
                                            </SaveButton>
                                        </Stack>
                                    </Box>
                                </Box>
                            </Form>
                        </FormikProvider>
                    </>
                }
            />
        </div>
    );
};
